import groupBy from 'lodash/groupBy'

import { AstraBadge, AstraParagraph, AstraTooltip, DATE_TEMPLATES, diff, format } from '~/astra'
import { PractitionerChipWithTooltip } from '~/components'
import { usePractitioners } from '~/storm'

import { DatePractitionerCell } from '../../shared'

type Props = {
    selectedCells: DatePractitionerCell[]
}

export const Header = ({ selectedCells }: Props) => {
    const selectedPractitionerShortNames = usePractitioners({ where: { id: { in: selectedCells.map(c => c.practitionerId) } } })
        .map(p => p.short_name)
        .filter(Boolean)

    const uniqueSelectedPractitionerShortNames = [...new Set(selectedPractitionerShortNames)].reverse()

    const selectedDates = selectedCells.map(({ date }) => date)
    const uniqueSelectedDates = [...new Set(selectedDates)].sort((a, b) => diff(a, b))
    const firstSelectedDate = uniqueSelectedDates.at(0)

    return (
        <div className="flex items-center justify-between border-b px-3 pb-3">
            <div className="flex items-center gap-2">
                {firstSelectedDate && <AstraParagraph>{format(firstSelectedDate, DATE_TEMPLATES.longMonth)}</AstraParagraph>}
                {uniqueSelectedDates.length > 1 && (
                    <AstraTooltip
                        tooltipContent={Object.entries(groupBy(uniqueSelectedDates.slice(1), date => format(date, 'MMMM')))
                            .map(([month, dates]) => `${dates.map(date => format(date, 'D.')).join(', ')} ${month}`)
                            .join(' og ')}
                    >
                        <div className="pointer-events-auto">
                            <AstraBadge text={`+${uniqueSelectedDates.length - 1}`} />
                        </div>
                    </AstraTooltip>
                )}
            </div>

            <div className="flex items-center gap-2">
                {uniqueSelectedPractitionerShortNames.length > 0 && (
                    <PractitionerChipWithTooltip shortName={uniqueSelectedPractitionerShortNames[0] ?? ''} size="medium" />
                )}
                {uniqueSelectedPractitionerShortNames.length > 1 && (
                    <AstraTooltip tooltipContent={uniqueSelectedPractitionerShortNames.filter((_, i) => i > 0).join(', ')}>
                        <div className="pointer-events-auto">
                            <AstraBadge text={`+${uniqueSelectedPractitionerShortNames.length - 1}`} />
                        </div>
                    </AstraTooltip>
                )}
            </div>
        </div>
    )
}
